import React, {useEffect, useState} from "react";
import storage from "../../../lib/utils/storage";
import {renderActions} from "../Devices/Device";
import Button from "react-bootstrap/Button";
import Badge from 'react-bootstrap/Badge';
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faHeart} from "@fortawesome/free-regular-svg-icons";
import {faCheck, faXmark, faHeart as faHeartSolid} from "@fortawesome/free-solid-svg-icons";

import {ListGroup} from "react-bootstrap";
import ReactJsonView from "@microlink/react-json-view";


function BondNode({bond, path, parentU, label, reloadFavorites, ...props}) {
    const [u, setU] = useState(parentU);
    const [uu, setUU] = useState("");
    const [obj, setObj] = useState({});
    const [isOpen, setIsOpen] = useState(props.isOpen || storage.loadIsOpen(path));
    const [isFavorite, setIsFavorite] = useState(getIsFavorite());
    const [isLoading, setIsLoading] = useState(false);
    const [isSavingAttr, setIsSavingAttr] = useState(true);
    const [attributeComponents, setAttributeComponents] = useState(null);

    useEffect(() => {
        if (isOpen) reload();
        storage.saveIsOpen(path, isOpen);
    }, [isOpen]); // eslint-disable-line

    useEffect(() => {
        if (isOpen && u && u !== parentU) reload();
        setU(parentU);
    }, [parentU]); // eslint-disable-line

    useEffect(() => {
        if (obj) renderObj();
    }, [obj, isSavingAttr]); // eslint-disable-line


    useEffect(() => {
        if (isOpen && props.reloadTimestamp) reload();
    }, [props.reloadTimestamp]); // eslint-disable-line


    function reload() {
        if (isLoading) return;
        setIsLoading(true);

        bond.request(path).then((result) => {
            setIsLoading(false);
            if (result === undefined) return;
            setObj(result);
            if (result["_"] && u !== result["_"]) setU(result["_"]);
            if (result["__"] && uu !== result["__"]) setUU(result["__"]);
            renderObj();
            setIsSavingAttr(false);
        }, (error) => {
            console.log(error);
            setIsLoading(false);
            setIsSavingAttr(false);
        });
    }

    function updateAttr(attr, newValue, target) {
        let value = obj[attr];

        if (newValue !== value) {
            obj[attr] = parseAttrClass(newValue);
            setObj(obj);
            renderObj();
        }
    }

    function parseAttrClass(input) {
        if (input === "true" || input === "false") return input === "true";
        if (input === "null") return null
        if (/^-?\d+$/.test(input)) return parseInt(input);
        if (/^-?\d*\.\d+$/.test(input)) return parseFloat(input);
        return input;
    }

    function saveAttr(attr, value) {
        const update = {};
        update[attr] = obj[attr];
        setIsSavingAttr(true);
        bond.request(path, update).then((result) => {
            result.json().then((response) => {
                if (response["s"] > 299) {
                    setIsSavingAttr(false);
                } else {
                    reload();
                }
            });
        }).catch((error) => {
            console.error("Error updating attribute: ", error);
            setIsSavingAttr(false);
        });
    }

    function getAttrComponent(attr, value) {
        if (props.customAttrComponent) {
            let customComponent = props.customAttrComponent(attr, value);
            if (customComponent) return customComponent;
        }

        if (attr === "actions") return renderActions(value, bond, path);

        if (Array.isArray(value))
            return (<li key={path+attr}>
                <ListGroup as="ul" className={"bondNodeArray"}>
                    <ListGroup.Item as="li" active variant={"secondary"}>
                        {attr}
                    </ListGroup.Item>
                    {value.map((item, index) => (<ListGroup.Item as="li" key={attr + "_" + index}>
                        {JSON.stringify(item)}
                    </ListGroup.Item>))}
                </ListGroup>
            </li>);
        if (value && typeof value == "object") {
            if (value["_"] && value["_"].length > 0) {
                return (<BondNode
                    key={path + attr}
                    parentU={value["_"]}
                    bond={bond}
                    path={path + attr + "/"}
                    label={attr}
                />);
            } else {
                return <div key={path + attr}>
                    <InputGroup className="bondNodeAttrInputGroup bondTreeNodeJson" >
                        <InputGroup.Text className={"w-100"}>{attr}</InputGroup.Text>
                        <ReactJsonView
                            src={value ? value : {}}
                            className={"bondTreeNodeJson"}
                            theme={"tomorrow"}
                            name={false}
                            displayObjectSize={false}
                            displayDataTypes={false}
                            disabled={isSavingAttr}
                            onEdit={(edit) => {
                                updateAttr(attr, edit["updated_src"]);
                                saveAttr(attr);
                            }}
                            defaultValue={"value"}
                            onAdd={(edit) => {
                                console.log("onAdd", edit);
                                updateAttr(attr, edit["updated_src"]);
                                saveAttr(attr);
                            }}
                        />
                    </InputGroup>
                </div>
            }
        }
        return (<li key={path + attr}>
            <InputGroup className="bondNodeAttrInputGroup">
                <InputGroup.Text id="basic-addon1">{attr}</InputGroup.Text>
                {typeof value === "boolean" ?
                    <Button variant={obj[attr] ? "success" : "secondary"} className={"bondNodeAttrToggle"}
                            onClick={() => updateAttr(attr, !obj[attr])} disabled={isSavingAttr}>
                        {obj[attr] ? <><FontAwesomeIcon icon={faCheck} className=''/> true</> : <><FontAwesomeIcon
                            icon={faXmark} className=''/> false</>}
                    </Button> : <Form.Control
                        value={value === null ? "null" : value}
                        disabled={isSavingAttr}
                        onChange={(e) => updateAttr(attr, e.target.value)}
                    />}
                <Button variant={"outline-secondary"}
                        onClick={(e) => {
                            saveAttr(attr);
                        }}
                        disabled={isSavingAttr}>
                    <FontAwesomeIcon icon={faFloppyDisk} className=''/>
                </Button>
            </InputGroup>
        </li>);
    }

    function toggleFavorite() {
        const favoriteKey = "favorites_" + bond.id;
        let favorites = localStorage.getItem(favoriteKey) || "{}";
        favorites = JSON.parse(favorites);
        if (favorites[path]) {
            delete favorites[path];
            setIsFavorite(false);
        } else {
            favorites[path] = "1";
            setIsFavorite(true);
        }


        localStorage.setItem(favoriteKey, JSON.stringify(favorites));
        if (reloadFavorites) reloadFavorites();
    }


    function getIsFavorite() {
        const favoriteKey = "favorites_" + bond.id;
        let favorites = localStorage.getItem(favoriteKey) || "{}";
        favorites = JSON.parse(favorites);
        return favorites[path];
    }

    function renderObj() {
        let _attributeComponents = [];
        if (!obj || Object.entries(obj).length === 0) return;

        for (let [attr, value] of Object.entries(obj)) {
            if (attr === "_") continue;
            if (attr === "__") continue;
            _attributeComponents.push(getAttrComponent(attr, value));
        }
        if (props.extraComponents) _attributeComponents = _attributeComponents.concat(props.extraComponents);
        if (props.extraComponentsStart) _attributeComponents = props.extraComponentsStart.concat(_attributeComponents);

        setAttributeComponents(_attributeComponents);
    }

    let customLabel = label;
    if (props.customLabel) customLabel = props.customLabel(obj); else if (obj["name"]) customLabel = label + " | " + obj["name"];

    return (<li>
        <Button
            className={"bondNodeButton " + (props.className ? props.className : "")}
            onClick={() => setIsOpen(!isOpen)}
            variant={isOpen ? (props.customVariant ? props.customVariant : "primary") : (props.customVariant ? "outline-" + props.customVariant : "outline-primary")}
            disabled={isLoading}>
            {customLabel}
        </Button>
        {isOpen || isFavorite ? <Button variant={"dark"} className={"ms-2 favoriteIcon"} onClick={toggleFavorite}>
            <FontAwesomeIcon icon={isFavorite ? faHeartSolid : faHeart}/>
        </Button> : ""}
        {u ? <Badge bg={"secondary"} className={"ms-2"}>_: {u}</Badge> : ''}
        {uu && isOpen ? <Badge bg={"secondary"} className={"ms-2"}>__: {uu} </Badge> : ''}
        {isOpen ? <ul>{attributeComponents}</ul> : <></>}
    </li>);
}

export default BondNode;
